import { gsap } from "gsap";
import { animateObserver, fadeIn } from "../../../js/animations/animations";
import { isAuthor, isMobile } from "../../../js/utils";

(() => {
  const brhSlideDetails = () => {
    const selectors = {
      component: "brh-slide-details",
    };

    const init = () => {
      const parentElement = Array.from(document.getElementsByClassName(selectors.component));
      if (parentElement) {
        bcl.u.loadStyleSheet("/etc.clientlibs/barcelo/clientlibs/clientlib-brhSlideDetails.css");

        parentElement.forEach((element) => {
          const swiperElement = element?.querySelector(".swiper");
          if (swiperElement) {
            const wrapper = swiperElement.firstElementChild;
            const slideLength = element.querySelectorAll(".brh-slide-gallery-item").length;
            [...element.querySelector(".swiper-wrapper").children].forEach((element) => {
              element.classList.add("swiper-slide");
            });
            if (swiperElement.classList.contains("mod--big") && slideLength > 3) {
              const swiper = new window.Swiper(element.querySelector(".swiper"), {
                slidesPerView: window.innerWidth > 1024 ? 3 : 1.3,
                spaceBetween: window.innerWidth > 1024 ? 10 : 16,
                allowTouchMove: window.innerWidth > 1024 ? false : true,
                freeMode: true,
                loop: true,
                centeredSlides: true,
                navigation: {
                  nextEl: ".swiper-button-next",
                  prevEl: ".swiper-button-prev",
                },
              });

              window.addEventListener("resize", () => {
                swiper.params.slidesPerView = window.innerWidth > 1024 ? 3 : 1.3;
                swiper.params.spaceBetween = window.innerWidth > 1024 ? 10 : 16;
                swiper.params.allowTouchMove = window.innerWidth > 1024 ? false : true;
                swiper.update();
              });
            } else if (swiperElement.classList.contains("mod--small") && slideLength > 3) {
              const swiper = new window.Swiper(element.querySelector(".swiper"), {
                slidesPerView: window.innerWidth > 1024 ? 6 : 1.3,
                spaceBetween: window.innerWidth > 1024 ? 10 : 16,
                freeMode: false,
                allowTouchMove: window.innerWidth > 1024 ? false : true,
                loop: true,
                centeredSlides: window.innerWidth > 1024 ? false : true,
                navigation: {
                  nextEl: ".swiper-button-next",
                  prevEl: ".swiper-button-prev",
                },
              });
              const originalSlides = swiperElement.querySelectorAll(".swiper-slide");
              originalSlides.forEach((originalSlide) => {
                const clone = originalSlide.cloneNode(true);
                element.querySelector(".swiper-wrapper").appendChild(clone);
                swiper.update();
              });

              window.addEventListener("resize", () => {
                swiper.params.slidesPerView = window.innerWidth > 1024 ? 6 : 1.3;
                swiper.params.spaceBetween = window.innerWidth > 1024 ? 10 : 16;
                swiper.params.allowTouchMove = window.innerWidth > 1024 ? false : true;
                swiper.params.centeredSlides = window.innerWidth > 1024 ? false : true;
                swiper.update();
              });
            } else if (slideLength <= 3 && window.innerWidth > 1024) {
              const arrowNext = element.querySelector(".swiper-button-next");
              const arrowPrev = element.querySelector(".swiper-button-prev");
              wrapper.style.justifyContent = "center";
              wrapper.style.gap = "10px";
              swiperElement.classList.add("mod--hide-shadows");

              if (arrowNext && arrowPrev) {
                arrowNext.style.display = "none";
                arrowPrev.style.display = "none";
              }
            } else if (window.innerWidth < 1024) {
              new window.Swiper(element.querySelector(".swiper"), {
                slidesPerView: 1.3,
                spaceBetween: 16,
                freeMode: false,
                allowTouchMove: true,
                loop: true,
                centeredSlides: true,
                navigation: {
                  nextEl: ".swiper-button-next",
                  prevEl: ".swiper-button-prev",
                },
              });
            }
          }
        });
      }

      //== Animations
      if (!isMobile() && !isAuthor()) {
        const carousels = document.querySelectorAll(`.${selectors.component}`);
        if (carousels.length > 0) {
          carousels?.forEach((element) => {
            const wrappers = element.querySelectorAll(".swiper-wrapper");
            const appearances = gsap.timeline();
            wrappers.length > 0 && appearances.add(fadeIn({ classElement: wrappers, duration: 2 }), 0);
            appearances.pause();

            animateObserver({ elementToObserve: element, animation: () => appearances, threshold: 0 });
          });
        }
      }
    };
    init();
  };
  document.addEventListener("DOMContentLoaded", brhSlideDetails);
})();
